<template>
  <List :searchBox="searchBox" :fullscreen="fullscreen">
    <v-list-item-group v-if="items.length" color="primary">
      <ListItemAvatarThreeL
        v-for="(item, i) of items"
        :key="i"
        :title="item[itemTitle]"
        :subtitle="item[itemSubtitle]"
        :isSubtitlePrice="isSubtitlePrice"
        :text="item[itemText]"
        :isTextPrice="isTextPrice"
        @clicked="$emit('clicked', item)"
      />
    </v-list-item-group>
    <p v-else class="text-center font-weight-bold white py-3">Nenhum registro encontrado</p>
  </List>  
</template>

<script>
import List from './List';
import ListItemAvatarThreeL from './ListItemAvatarThreeL';

export default {
  name: 'ListThreeItemsSelect',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    itemTitle: {
      type: String,
      default: 'title'
    },
    itemSubtitle: {
      default: ''
    },
    itemText: {
      default: ''
    },
    isSubtitlePrice: {
      type: Boolean,
      default: false
    },
    isTextPrice: {
      type: Boolean,
      default: false
    },
    searchBox: {
      type: Boolean,
      default: false
    },
    fullscreen: {
      type: Boolean,
      default: false
    }
  },
  components: {
    List,
    ListItemAvatarThreeL
  }
}
</script>

<style>

</style>